import { type SyntheticEvent, useState } from 'react';

import { debounce } from '@mui/material';

export interface SearchBarState {
  isDirty: boolean;
  onInputChange: (_event: SyntheticEvent<Element, Event>, value: string) => void;
  searchValue: string;
}

export const useSearchBarState = (): SearchBarState => {
  const [searchValue, setSearchValue] = useState('');
  const [isDirty, setIsDirty] = useState(false);

  const onInputChange = (_event: SyntheticEvent<Element, Event>, value: string) => {
    setSearchValue(value);
    if (value === '') {
      setIsDirty(false);
    } else {
      setIsDirty(true);
    }
  };

  return {
    isDirty,
    onInputChange: debounce(onInputChange, 500),
    searchValue,
  };
};
